import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import React from 'react'
import TextLink from 'LuxKit/TextLink'
import FormatCurrency from 'components/Common/FormatCurrency'
import { LUXURY_PLUS } from 'luxPlus/constants/base'

interface Props {
  variant: 'pastDates' | 'soldOut' | 'unavailable' | 'luxplus' | 'insurance' | undefined
  to?: string
  savings?: number
}

function CartReviewBanner(props: Props) {
  const {
    variant,
    to,
    savings,
  } = props

  switch (variant) {
    case 'pastDates':
      return (
        <MessageBanner kind="warning">
          Your selected dates are in the past{' '}
          <TextLink weight="bold" to={to} target="_blank">
            Check availability
          </TextLink>
        </MessageBanner>
      )
    case 'soldOut':
      return (
        <MessageBanner kind="warning" density="compact" icon={<LineInfoCircleIcon />}>
          Sold out for your dates{' '}
          <TextLink weight="bold" to={to}target="_blank">Check availability</TextLink>
        </MessageBanner>
      )
    case 'unavailable':
      return (
        <MessageBanner kind="warning" density="compact" icon={<LineInfoCircleIcon />}>
          Offer no longer available{' '}
          <TextLink weight="bold" to={to}target="_blank">View similar offers</TextLink>
        </MessageBanner>
      )
    case 'luxplus':
      if (savings) {
        return (
          <MessageBanner kind="promotional-primary" density="compact" icon={<LineInfoCircleIcon />}>
            Add {LUXURY_PLUS.PROGRAM_NAME} to save an extra <FormatCurrency value={savings} format="preciseDollar" /> on this booking & unlock member-only benefits all year round
          </MessageBanner>
        ) } else {
        return (
          <MessageBanner kind="promotional-primary">
            Save <FormatCurrency value={500} /> on the joining fee when you book an eligible offer{' '}
            <TextLink weight="bold" to={to}>Search {LUXURY_PLUS.PROGRAM_NAME} offers</TextLink>
          </MessageBanner>
        )
      }
    case 'insurance':
      return (
        <MessageBanner kind="warning" icon={<LineInfoCircleIcon />}>
          Please select an eligible product from your cart to proceed with Travel Protection.
        </MessageBanner>
      )

    default:
      return null
  }
}

export default CartReviewBanner
